import * as React from "react"
import { Box } from "@mui/material"
import GenericRadioButton from "src/v2/components/radio-button/generic-radio-button"
import PropTypes from "prop-types"

const RadioButtonAccessLevel = ({ value, onChange }) => {
    return (
        <Box
            sx={{
                width: "100%",
            }}
        >
            <GenericRadioButton
                defaultRadioValue={value}
                title="Nível de acesso"
                radioButtonItems={[
                    { value: "PUBLIC", label: "Público" },
                    { value: "PRIVATE", label: "Privado" },
                ]}
                onChange={onChange}
            />
        </Box>
    )
}

RadioButtonAccessLevel.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
}

export default RadioButtonAccessLevel
